<template>
  <div class="row content-data"  >
    <Navbar/>
    <div class="col pdf-data">
      <div id="pdfView">
        <div class="d-flex">

          <div class="ml-auto">

          </div>
        </div>


        <vue-html2pdf
            :show-layout="controlValue.showLayout"
            :float-layout="controlValue.floatLayout"
            :enable-download="controlValue.enableDownload"
            :preview-modal="controlValue.previewModal"
            :filename="controlValue.filename"
            :paginate-elements-by-height="controlValue.paginateElementsByHeight"
            :pdf-quality="controlValue.pdfQuality"
            :pdf-format="controlValue.pdfFormat"
            :pdf-orientation="controlValue.pdfOrientation"
            :pdf-content-width="controlValue.pdfContentWidth"
            :manual-pagination="controlValue.manualPagination"
            :html-to-pdf-options="htmlToPdfOptions"
            @progress="onProgress($event)"
            @startPagination="startPagination()"
            @hasPaginated="hasPaginated()"
            @beforeDownload="beforeDownload($event)"
            @hasDownloaded="hasDownloaded($event)"
            ref="html2Pdf"
        >
          <pdf-content :certificate="certificate" @domRendered="domRendered()" slot="pdf-content" />
        </vue-html2pdf>

        <section class="title-container">
          <h1 class="title-header">Vue HTML2PDF</h1>
        </section>


      </div>

    </div>

    <div class="col options-container">
      <div class="row" >
        <div class="col card text-white bg-primary  options-items" style="max-width: 18rem;">
          <div class="card-header">Huasipungo</div>
          <div class="card-body">
            <h5 class="card-title">Significado</h5>
            <h6 class="card-title">Terreno que un hacendado proporciona a un peón para que siembre sus propios alimentos a cambio de que trabaje para él; es frecuente en el área serrana de los Andes.</h6>
          </div>
        </div>
        <div class="col card text-white bg-secondary options-items" style="max-width: 18rem;">
          <div class="card-header">Amor</div>
          <div class="card-body">
            <h5 class="card-title">Significado</h5>
            <h6 class="card-title">La palabra amor no existe en quechua, porque proviene de latín. Pero si existe una palabra referente a la persona amada, “warmayanay”</h6>
          </div>
        </div>
      </div>
      <div class="options-left card text-center">
        <div class="card-header">
          Descargar
        </div>
        <div class="card-body">
          <h5 class="card-title">Felicidades</h5>
          <p class="card-text">Gracias por completar el curso</p>
          <controls-container :progress="progress" @generateReport="downloadPdf()" />
        </div>
        <div class="card-footer text-muted">
           KichwaCode
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PdfContent from "@/components/PdfView/PdfGenerator/PdfContent";
// import VueHtml2pdf from "@/components/VueHtml2pdf";
import ControlsContainer from "@/components/PdfView/PdfGenerator/ControlsContainer";
import VueHtml2pdf from 'vue-html2pdf'
// import VueHtml2pdf from "vue-html2pdf-test";
import { mapFields } from "vuex-map-fields";
import Navbar from "@/components/Navbar";
import axios from "axios";
import constants from "@/utils/constants";

export default {
  name: "app",

  data() {
    return {
      contentRendered: false,
      progress: 0,
      certificate:{
        user:'Tu Nombre Aqui',
        dateStamp:new Date().toISOString().replace('T',':').replace('Z','').replace('.','')
      },
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },

  computed: {
    ...mapFields(["controlValue"]),

    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: "KichwaCodeCertificate.pdf",

        image: {
          type: "jpeg",
          quality: 0.98,
        },

        enableLinks: true,

        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },

        jsPDF: {
          unit: "in",
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      };
    },
  },

  methods: {
    async downloadPdf() {
      if (!(await this.validateControlValue())) return;

      this.$refs.html2Pdf.generatePdf();
    },

    validateControlValue() {
      if (this.controlValue.pdfQuality > 2) {
        alert("pdf-quality value should only be 0 - 2");
        this.controlValue.pdfQuality = 2;

        return false;
      }

      if (!this.controlValue.paginateElementsByHeight) {
        alert("paginate-elements-by-height value cannot be empty");
        this.controlValue.paginateElementsByHeight = 1400;

        return false;
      }

      const paperSizes = [
        "a0",
        "a1",
        "a2",
        "a3",
        "a4",
        "letter",
        "legal",
        "a5",
        "a6",
        "a7",
        "a8",
        "a9",
        "a10",
      ];

      if (!paperSizes.includes(this.controlValue.pdfFormat)) {
        alert(`pdf-format value should only be ${paperSizes}`);
        this.controlValue.pdfFormat = "a4";

        return false;
      }

      if (!this.controlValue.pdfOrientation) {
        alert("pdf-orientation value cannot be empty");
        this.controlValue.pdfOrientation = "portrait";

        return false;
      }

      if (!this.controlValue.pdfContentWidth) {
        alert("pdf-content-width value cannot be empty");
        this.controlValue.pdfContentWidth = "800px";

        return false;
      }

      return true;
    },

    onProgress(progress) {
      this.progress = progress;
      console.log(`PDF generation progress: ${progress}%`)
    },

    startPagination() {
      console.log(`PDF has started pagination`)
    },

    hasPaginated () {
      console.log(`PDF has been paginated`)
    },



    hasDownloaded (blobPdf) {
      console.log(`PDF has downloaded yehey`)
      this.pdfDownloaded = true
      console.log(blobPdf)
    },

    domRendered() {
      console.log("Dom Has Rendered");
      this.contentRendered = true;
    },

    onBlobGenerate(blob) {
      console.log(blob);
    },
    getCertificate: function() {
      const bodyParameters = {
        certificatePath: this.$route.params.id
      };
      axios.post(constants.endpointList.certificate,
          bodyParameters,
      ).then((result)=>{
        this.certificate=result.data;


      }).catch((error)=>{
        console.log(error);
      });

    },

  },
  created: function(){
    this.getCertificate();
  },

  components: {
    Navbar,
    VueHtml2pdf,
    PdfContent,
    ControlsContainer,
  },
};
</script>

<style lang="scss"  >
.pdf-data{
  margin-top: 5%;
}
#pdfView {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #141e30; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to bottom,
    #243b55,
    #141e30
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to bottom,
    #243b55,
    #141e30
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  flex-direction: column;
  overflow: hidden;

  .title-container {
    min-height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  .title-header {
    color: #fff;
    padding: 25px 50px;
    border: 5px solid #fff;
    border-radius: 5px;
    opacity: 0;
  }
}
.content-data{
  height: 25%;
  background: linear-gradient(
          to bottom,
          #243b55,
          #141e30
  );
}
.options-container{
  background: linear-gradient(
          to bottom,
          #243b55,
          #141e30
  );
}
.options-left{
  margin-top: 5%;

  width: 100%;
  height: 46%;
}
.options-items{
  width: 100%;
  color: white;
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 10%;
}
</style>
